import { inject, Injectable } from '@angular/core';
import { API_URLS, WebServiceProvider } from '@pinnakl/core/web-services';
import { CurrencyModel, FxRate } from '@pinnakl/poems/domain';

@Injectable({ providedIn: 'root' })
export class CommonDataApiService {
  private readonly wsp = inject(WebServiceProvider);
  private readonly apiUrls = inject(API_URLS);

  getFxRates(): Promise<FxRate[]> {
    return this.wsp.get<FxRate[]>({ endpoint: this.apiUrls.fxRatesCurrenciesLatestV3 });
  }

  getCurrencies(): Promise<CurrencyModel[]> {
    return this.wsp.get<CurrencyModel[]>({ endpoint: this.apiUrls.globalCurrencies });
  }
}
